import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { MessageBody } from '../interfaces/MessageBody';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class MessagesService {
    token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjA5N2E1NDhhNDM4ZmYwNGM2OTE2MWU4NTAwMGNhMDNkZWY2YTIzNWFkNjA0Zjg5M2JmMDNhZTRjNGFiNzQyNmNkYjI2NTM5YzYxNjE5OTZhIn0.eyJhdWQiOiIxIiwianRpIjoiMDk3YTU0OGE0MzhmZjA0YzY5MTYxZTg1MDAwY2EwM2RlZjZhMjM1YWQ2MDRmODkzYmYwM2FlNGM0YWI3NDI2Y2RiMjY1MzljNjE2MTk5NmEiLCJpYXQiOjE1ODU1ODA0ODgsIm5iZiI6MTU4NTU4MDQ4OCwiZXhwIjoxNjE3MTE2NDg4LCJzdWIiOiIzMzg0Iiwic2NvcGVzIjpbXX0.m3-JGaKe4f4ulXewVjMNCOwM90nD7DXpEmRqJO7liviPpTGEAdY0aq0qmwpj0pu86eqtjEBFTilyZZBmW54QOgwXYeWGqIMq1Go1h1he81OUDwRHbuYi28z2XcJkKkQyrO0-8FD-bY6bHUhLJSXx5kBoA-TGM-TCZdxjMLmBhZ1tgvVRZnCYPR_RMRsCEXQkdVBxBYMQU7b84KdHXY4PszYOSTPBURFQW3NT4V7F4lkb_k15nts73XvVdVfDGr72ydmcpH2ZPKAj-5vxviyi1AApEOdY5LoZ9EGb4kBbH1XVpYN1NQcLCf3pMbKfuA3csNOGdrW93HqMnpSmvP5l4niXsd-Syz4Er2JVsQsQrwULZUPmsUDjhL713n2UwwCinHZ9iic1XP-uXgksNAUh560zeRHfV1ybvTaieWaN-ApVpoOgfh56ncWbSRnv70NyieHW2UIVkddt5CX4zxcFPByWevoiObZQohy9whUn0KbV3PAXHPLA2fOKuQK6E3uy_EjTwH8agawAvhuTzQsThYVpibMTf-CSVFYc6T6jKE2I0X7hirr7aKGJ9LdDTxx7VoVE_TfcDAOTs5XoxGH8gV0B5-BGsbWnnBVtGLzysb9KDKqseVMTcaQj40pyP4yeibSLT-cIpT4q9N0TnjCAzuv7RpTqzmdpyqCGCsFxg_U';
    options = {
        headers: new HttpHeaders({
            // tslint:disable-next-line:object-literal-key-quotes
            'Authorization': `Bearer ${this.token}`
        })
    };

    constructor(private http: HttpClient) { }

    public _areMultipleRecepientsSelected= new BehaviorSubject<boolean>(false);
    areMultipleRecepientsSelected = this._areMultipleRecepientsSelected.asObservable();
    
    private _reloadMessages = new BehaviorSubject<boolean>(null);
    reloadMessages = this._reloadMessages.asObservable();

    setReloadMessages(reloadState) {
        this._reloadMessages.next(reloadState);
    }

    getReloadMessages() {
        return this._reloadMessages;
    }

    private _searchTermUsers = new BehaviorSubject<string>(null);
    searchTerm = this._searchTermUsers.asObservable();

    setSearchTermUsers(searchTerm) {
        this._searchTermUsers.next(searchTerm);
    }

    getSearchTermUsers() {
        return this._searchTermUsers;
    }


    getMessages(perPage: number, page: number, sortType: string = 'desc', searchText?: string) {
        if (searchText) {
            return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/messages?&per_page=${perPage}&page=${page}&sort[created_at]=${sortType}&search=${searchText}`);
        }

        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/messages?&per_page=${perPage}&page=${page}&sort[created_at]=${sortType}`);


    }
    searchMessages(perPage: number, page: number, searchText: string) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/messages?sort[created_at]=desc&is_paginated=0&search=${searchText}`);
    }

    sendMessageToUsers(body: MessageBody) {
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/messages`, body)
    }

    getAllRoles() {
        return this.http.get(environment.url + `admin/roles`)
    }

    getMessagesCount$(searchText?: string) {
        if (searchText) {
            return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/messages?is_paginated=0&page=1&search=${searchText}`)
        }
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/messages?is_paginated=0&page=1`)
    }

    getUsersByRole() {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users?is_paginated=0`).pipe(map((res: any) => {
            return res.map(x => (
                {
                    id: x.id,
                    national_id: x.national_id,
                    name: x.name,
                    image_path: x.image_path,
                    roles: x.roles[0].name,
                    classes: x.classes,
                    grades: x.grades,
                }
            ))

        }))
    }

    getAllGrades() {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/grades`);
    }

    getAllGates() {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/gates`);
    }

    getAllRoutes() {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/routes`)
    }




    filterUsers(query) {

        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users?is_paginated=0&${query}`)
    }

    deleteMessage(messageId) {
        return this.http.delete(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/messages/${messageId}`);
    }
}